import { ArrowUpRightIcon, PencilSquareIcon } from "@heroicons/react/24/outline";
import moment from "moment";
import "moment/locale/nl-be";
import React from "react";
import { getUser } from "../../../Localstorage/localstorage";

const DagBoek = ({ toonEdit, item, editTekst }) => {
  const user = getUser();
  return (
    <li
      onClick={() => toonEdit(item)}
      className="mb-2 flex cursor-pointer list-none items-center justify-between gap-3 rounded-xl border border-wa-border bg-wa-panel2 px-3 py-4 shadow-sm transition-colors hover:border-wa-accent/30 hover:bg-wa-hover sm:px-4"
    >
      <div className="min-w-0 flex-1">
        <p className="line-clamp-2 text-sm font-semibold leading-snug text-wa-text">
          {item?.eetdagboek_title}
        </p>
        <div className="mt-1 text-xs leading-5 text-wa-muted">
          <time dateTime={item?.eetdagboek_datum}>
            {moment(item?.eetdagboek_datum).locale("nl-be").format("DD/MM/YYYY LT")}
          </time>
        </div>
      </div>
      <div className="flex flex-none items-center">
        <button
          type="button"
          onClick={(e) => {
            if (user.role === 2) {
              e.stopPropagation();
              editTekst(item, "wijzigen");
            }
          }}
          className={`rounded-full bg-wa-accent p-2.5 text-wa-onaccent shadow-sm ring-1 ring-wa-accent/40 transition hover:bg-wa-accentdeep hover:ring-wa-accent focus:outline-none focus-visible:ring-2 focus-visible:ring-wa-accent ${
            user.role !== 2 ? "pointer-events-none" : ""
          }`}
        >
          {user.role == 2 ? (
            <PencilSquareIcon className="h-5 w-5" aria-hidden="true" />
          ) : (
            <ArrowUpRightIcon className="h-5 w-5" aria-hidden="true" />
          )}
        </button>
      </div>
    </li>
  );
};

export default DagBoek;
